import { useState } from 'preact/hooks';
import { openAlert } from '../../../../components/alert/hooks';
import { GET, GET_WARRANTY_CODE } from '../../../../services';
import { useMutation } from '@tanstack/react-query';

export const useGetWarrantyCode = () => {
  const [dataSource, setDataSource] = useState([]);

  const { mutate, isPending } = useMutation({
    mutationFn: async ({ warrantyCode, barcode }) => {
      const response = await GET(GET_WARRANTY_CODE(warrantyCode, barcode));
      return response;
    },
    onSuccess: (response) => {
      openAlert({ model: 'message', type: 'success', message: response.message });
      setDataSource(response.result);
    },
  });

  return { mutate, loading: isPending, dataSource };
};
